// Arabic visitor-type workflow strings (module 07, ADR-027) — DEVELOPMENT DRAFT by Claude (PD-011);
// unreviewed until decision H-10 names a reviewer.
import type { enWorkflows } from './en-workflows.ts';
import type { Message } from './types.ts';

export const arWorkflows: { readonly [K in keyof typeof enWorkflows]: Message } = {
  'specialist.hr-assessor': 'مقيّم الموارد البشرية (ملاحظات المرشحين الخاصة بالموارد البشرية، راعي الموارد البشرية)',

  'vtw.api.assistedRecorded': 'الوصول بالمرافقة مسجّل مسبقًا لهذه الزيارة.',
  'vtw.api.notCandidateType': 'لا يتضمن نوع الزائر هذا معالجة للمرشحين.',
  'vtw.api.notDeliveryType': 'نوع الزائر هذا ليس سير عمل للتوصيل.',
  'vtw.api.alreadyLinked': 'هذا الزائر أو هذا التوصيل مرتبط مسبقًا.',
  'vtw.api.deliveryCompleted': 'تم إكمال مشاركة التوصيل هذه مسبقًا.',
  'vtw.api.handoverPending': 'سجّل التسليم أو الرفض في مكتب التوصيل أولًا.',
  'vtw.v.handoverAreaRequired': 'يتوجه زوار هذا النوع فقط إلى منطقة تسليم مفتوحة. اختر واحدة كوجهة.',
  'vtw.v.hrSponsorRequired': 'حدّد راعيًا من الموارد البشرية يحمل دور مقيّم الموارد البشرية في هذا الموقع قبل الإرسال.',
  'vtw.v.workOrderRequired': 'اربط هذه الزيارة بأمر عمل قبل الإرسال.',
  'vtw.v.workOrderNotCovering': 'أمر العمل أو التصريح المرتبط لا يغطي هذه الزيارة. راجع الأسباب في قسم أمر العمل.',
  'vtw.v.notProtocolOffice': 'اختر شخصًا من مكتب المراسم في هذا الموقع.',
  'vtw.v.notHrSponsor': 'اختر شخصًا يحمل دور مقيّم الموارد البشرية في هذا الموقع.',
  'vtw.v.deliveryAreaMismatch': 'هذا التوصيل في منطقة تسليم مختلفة عن وجهة الزيارة.',
  'vtw.v.waiveReason': 'اذكر سبب التنازل عن هذه الخطوة.',
  'vtw.v.purposeRequired': 'اذكر سبب حاجتك إلى قراءة هذه الملاحظات.',

  'cred.blocker.restricted_zone_not_authorised': 'تم اختيار منطقة مقيدة لكن لا يوجد لهذا الزائر تفويض معتمد للمنطقة المقيدة.',
  'cred.blocker.restricted_zone_identity': 'تحتاج المنطقة المقيدة إلى دليل هوية ساري المفعول حتى انتهاء بيانات الدخول.',
  'cred.blocker.restricted_zone_escort': 'تحتاج المنطقة المقيدة إلى مرافق معيّن للزيارة.',
  'cred.blocker.work_order_not_covering': 'لم يعد أمر العمل أو التصريح المرتبط يغطي هذه الزيارة.',

  'comms.key.protocol_notice': 'إشعار المراسم إلى جهة الاتصال والمسؤول عن المراسم',
  'vpolicy.ntf.t.protocol_notice': 'إشعار المراسم',

  'vtw.title': 'معالجة نوع الزائر',
  'vtw.intro': 'مُعدّة لنوع الزائر هذا. هذه الحقائق لا تمنح موافقة أو دخولًا أو صلاحية بحد ذاتها.',
  'vtw.none': 'لا يوجد',
  'vtw.choose': 'اختر…',
  'vtw.actions': 'الإجراءات',

  'vtw.protocol.title': 'المراسم',
  'vtw.protocol.contact': 'جهة اتصال المراسم',
  'vtw.protocol.owner': 'المسؤول عن المراسم',
  'vtw.protocol.notices': 'إشعارات المراسم',
  'vtw.protocol.noticesOn': 'تُرسل إلى جهة الاتصال والمسؤول',
  'vtw.protocol.noticesOff': 'لا تُرسل لنوع الزائر هذا',
  'vtw.protocol.route': 'مسار المرافقة',
  'vtw.protocol.routeMissing': 'مطلوب — لم يُحدد بعد',
  'vtw.protocol.routePoint': 'نقطة الالتقاء',
  'vtw.protocol.routeNote': 'ملاحظة المسار',
  'vtw.protocol.routeNoteHint': 'تظهر للاستقبال ليتمكن من إدخال الزائر. حتى 300 حرف.',
  'vtw.protocol.assistedAt': 'تم استقباله على مسار المرافقة {when} بواسطة {name}',
  'vtw.protocol.recordAssisted': 'تسجيل الوصول بالمرافقة',
  'vtw.protocol.itinerary': 'برنامج الزيارة الخاص',
  'vtw.protocol.itineraryRestricted': 'مسجّل — يظهر فقط لمكتب المراسم ولمضيفي الزيارة',
  'vtw.protocol.itineraryHint': 'لا يقرؤه إلا مكتب المراسم ومضيفو هذه الزيارة. لا يُرسل أبدًا في الإشعارات.',
  'vtw.protocol.factsHint': 'تصنيف كبار الشخصيات أو المسؤول لا يتجاوز أبدًا فحوص الموافقة أو الهوية أو الوصول.',
  'vtw.protocol.edit': 'تعديل المراسم',
  'vtw.protocol.editHint': 'يجب أن تكون جهة الاتصال والمسؤول من مكتب المراسم في هذا الموقع.',
  'vtw.protocol.officeHint': 'تظهر فقط أسماء العاملين في مكتب المراسم.',
  'vtw.protocol.steps': 'خطوات المراسم',
  'vtw.protocol.stepsHint': { zero: 'لا توجد خطوة مطلوبة معلّقة.', one: 'خطوة مطلوبة واحدة معلّقة.', two: 'خطوتان مطلوبتان معلّقتان.', few: '{count} خطوات مطلوبة معلّقة.', many: '{count} خطوة مطلوبة معلّقة.', other: '{count} خطوة مطلوبة معلّقة.' },
  'vtw.protocol.step': 'الخطوة',
  'vtw.protocol.status': 'الحالة',
  'vtw.protocol.recorded': 'التسجيل',
  'vtw.protocol.required': 'مطلوبة',
  'vtw.protocol.optional': 'اختيارية',
  'vtw.protocol.version': 'إصدار السياسة {n}',
  'vtw.protocol.complete': 'تحديد كمكتملة',
  'vtw.protocol.waive': 'التنازل',
  'vtw.protocol.stepNote': 'ملاحظة',
  'vtw.protocol.stepNoteHint': 'اختيارية. حتى 500 حرف.',
  'vtw.protocol.waiveHint': 'مطلوب: سبب التنازل عن هذه الخطوة.',
  'vtw.step.pending': 'معلّقة',
  'vtw.step.completed': 'مكتملة',
  'vtw.step.waived': 'متنازل عنها',
  'vtw.step.superseded': 'استُبدلت بسياسة لاحقة',

  'vtw.candidate.title': 'المرشح (الموارد البشرية)',
  'vtw.candidate.sponsor': 'راعي الموارد البشرية',
  'vtw.candidate.sponsorMissing': 'مطلوب — لم يُحدد بعد',
  'vtw.candidate.setSponsor': 'تحديد راعي الموارد البشرية',
  'vtw.candidate.sponsorHint': 'تظهر فقط أسماء من يحملون دور مقيّم الموارد البشرية في هذا الموقع.',
  'vtw.candidate.notes': 'ملاحظات خاصة بالموارد البشرية',
  'vtw.candidate.notesAvailable': 'يمكنك قراءتها لغرض مُعلن؛ وتُسجّل كل قراءة.',
  'vtw.candidate.notesRestricted': 'لا يقرأ ملاحظات التقييم إلا مقيّمو الموارد البشرية.',
  'vtw.candidate.purpose': 'الغرض',
  'vtw.candidate.purposeHint': 'تُسجّل كل قراءة في سجل التدقيق مع هذا الغرض.',
  'vtw.candidate.show': 'عرض الملاحظات',
  'vtw.candidate.noNotes': 'لا توجد ملاحظات بعد.',
  'vtw.candidate.correction': 'تصحيح',
  'vtw.candidate.redacted': 'أُزيلت بموجب قواعد الاحتفاظ.',
  'vtw.candidate.addNote': 'إضافة ملاحظة خاصة بالموارد البشرية',
  'vtw.candidate.addNoteHint': 'لا يمكن تعديل الملاحظات؛ أضف تصحيحًا بدلًا من ذلك. حتى 4,000 حرف.',
  'vtw.candidate.about': 'تخص',
  'vtw.candidate.aboutVisit': 'الزيارة بالكامل',
  'vtw.candidate.saveNote': 'حفظ الملاحظة',
  'vtw.purpose.hiring_decision': 'قرار التوظيف',
  'vtw.purpose.interview_panel': 'التحضير للجنة المقابلة',
  'vtw.purpose.candidate_request': 'طلب المرشح نفسه',
  'vtw.purpose.complaint_or_audit': 'شكوى أو تدقيق',

  'vtw.work.title': 'أمر العمل',
  'vtw.work.required': 'يحتاج نوع الزائر هذا إلى أمر عمل يغطي الزيارة.',
  'vtw.work.requiredWithPermit': 'يحتاج نوع الزائر هذا إلى أمر عمل وتصريح معتمد يغطيان الزيارة.',
  'vtw.work.optional': 'يمكن ربط أمر عمل بهذه الزيارة.',
  'vtw.work.unbound': 'لم يُربط أي أمر عمل بعد.',
  'vtw.work.order': 'أمر العمل',
  'vtw.work.permit': 'التصريح',
  'vtw.work.permitHint': 'التصاريح المعتمدة في هذا الموقع التي ما زالت سارية.',
  'vtw.work.validUntil': 'ساري حتى {when}',
  'vtw.work.coverage': 'التغطية',
  'vtw.work.evaluatedAt': 'تم التحقق {when}',
  'vtw.work.history': { one: 'سجل إعادة التقييم (1)', two: 'سجل إعادة التقييم (2)', few: 'سجل إعادة التقييم ({count})', many: 'سجل إعادة التقييم ({count})', other: 'سجل إعادة التقييم ({count})' },
  'vtw.work.liveCredentials': { one: 'بيانات دخول واحدة ما زالت فعّالة', two: 'بيانات دخول اثنتان ما زالتا فعّالتين', few: '{count} بيانات دخول ما زالت فعّالة', many: '{count} من بيانات الدخول ما زالت فعّالة', other: '{count} من بيانات الدخول ما زالت فعّالة' },
  'vtw.work.bind': 'ربط أمر عمل',
  'vtw.work.rebind': 'تغيير أمر العمل',
  'vtw.work.bindHint': 'يتم التحقق من التغطية الآن ومرة أخرى بعد كل تغيير في الزيارة.',
  'vtw.coverage.covered': 'مغطاة',
  'vtw.coverage.not_covered': 'غير مغطاة',
  'vtw.trigger.bound': 'الربط',
  'vtw.trigger.submitted': 'الإرسال',
  'vtw.trigger.visit_changed': 'تغيير الزيارة',
  'vtw.trigger.participants_changed': 'تغيير الزوار',
  'vtw.block.no_schedule': 'لا يوجد جدول للزيارة بعد.',
  'vtw.block.work_package_closed': 'أمر العمل مغلق.',
  'vtw.block.outside_work_package': 'تقع الزيارة خارج تواريخ أمر العمل.',
  'vtw.block.permit_required': 'يلزم تصريح معتمد.',
  'vtw.block.permit_not_approved': 'التصريح غير معتمد.',
  'vtw.block.permit_company': 'التصريح يخص شركة أخرى.',
  'vtw.block.permit_work_package': 'التصريح يخص أمر عمل آخر.',
  'vtw.block.permit_zone': 'التصريح لا يغطي وجهة الزيارة.',
  'vtw.block.permit_window': 'التصريح لا يغطي الزيارة كاملة (مثلًا بعد تمديد وقت الانتهاء).',
  'vtw.block.participant_not_on_permit': 'أحد الزوار غير مدرج في التصريح.',
  'vtw.permitStatus.draft': 'مسودة',
  'vtw.permitStatus.submitted': 'مُرسل',
  'vtw.permitStatus.approved': 'معتمد',
  'vtw.permitStatus.rejected': 'مرفوض',
  'vtw.permitStatus.invalidated': 'أُلغي اعتماده',
  'vtw.permitStatus.withdrawn': 'مسحوب',

  'vtw.delivery.title': 'التوصيل',
  'vtw.delivery.destinationOk': 'الوجهة منطقة تسليم معتمدة.',
  'vtw.delivery.destinationMissing': 'يجب أن تكون الوجهة منطقة تسليم مفتوحة.',
  'vtw.delivery.none': 'لم يُربط أي توصيل بعد.',
  'vtw.delivery.courier': 'المندوب',
  'vtw.delivery.packages': 'الطرود',
  'vtw.delivery.handover': 'التسليم',
  'vtw.delivery.presence': 'التواجد',
  'vtw.delivery.vehicle': 'المركبة',
  'vtw.delivery.record': 'سجل التوصيل',
  'vtw.delivery.person': 'الشخص',
  'vtw.delivery.courierFact': 'مكتب التوصيل',
  'vtw.delivery.packageCount': { one: 'طرد واحد', two: 'طردان', few: '{count} طرود', many: '{count} طردًا', other: '{count} طرد' },
  'vtw.delivery.recipient': 'إلى {name}',
  'vtw.delivery.completedBy': 'سجّل الإكمال {name}، {when}',
  'vtw.delivery.complete': 'تسجيل الإكمال',
  'vtw.delivery.link': 'ربط توصيل',
  'vtw.delivery.linkHint': 'اربط المندوب بتوصيل مسجّل في مكتب التوصيل.',
  'vtw.delivery.independenceHint': 'إكمال التسليم لا يسجّل أبدًا مغادرة المندوب أو المركبة؛ تُسجّل المغادرة بشكل منفصل.',
  'vtw.package.pending': 'بانتظار التسليم',
  'vtw.package.handed_over': 'تم التسليم',
  'vtw.package.refused': 'مرفوض',
  'vtw.presence.no_observation': 'لم يُرصد',
  'vtw.presence.observed_onsite': 'في الموقع',
  'vtw.presence.observed_departed': 'غادر',
  'vtw.presence.unknown_conflicting': 'غير معروف',

  'vtw.policy.title': 'معالجة نوع الزائر',
  'vtw.policy.hint': 'سلوك اختياري لنوع الزائر هذا. إنه إعداد: لا شيء يعتمد على اسم الفئة.',
  'vtw.policy.protocol': 'المراسم (جهة الاتصال، المسؤول، مسار المرافقة، الخطوات)',
  'vtw.policy.candidate': 'المرشح (راعي الموارد البشرية وملاحظاتها الخاصة)',
  'vtw.policy.workOrder': 'أمر العمل (الصيانة)',
  'vtw.policy.delivery': 'التوصيل (منطقة التسليم وسجل التوصيل)',
  'vtw.policy.contactHint': 'يجب أن يحمل دور مسؤول المراسم حيث تتم الزيارة.',
  'vtw.policy.notify': 'إرسال إشعارات المراسم',
  'vtw.policy.assistedRoute': 'مسار المرافقة',
  'vtw.policy.stepsHint': 'خطوات إضافية بعد مراحل الموافقة. لا تعيد أي نسخة لاحقة من السياسة كتابة الخطوات المكتملة.',
  'vtw.policy.stepKey': 'مفتاح الخطوة',
  'vtw.policy.stepLabelEn': 'التسمية (بالإنجليزية)',
  'vtw.policy.stepLabelAr': 'التسمية (بالعربية)',
  'vtw.policy.addStep': 'إضافة خطوة',
  'vtw.policy.removeStep': 'إزالة الخطوة',
  'vtw.policy.hrSponsorRequired': 'يلزم راعٍ من الموارد البشرية قبل الإرسال',
  'vtw.policy.workOrderRequired': 'يلزم أمر عمل يغطي الزيارة قبل الإرسال',
  'vtw.policy.permitRequired': 'يلزم تصريح معتمد يغطي الزيارة',

  'vtw.restricted.title': 'المناطق المقيدة في بيانات الدخول',
  'vtw.restricted.hint': 'لا تُدرج المنطقة المقيدة في بيانات الدخول إلا إذا كان لدى الزائر موافقة المنطقة المقيدة والأدلة أدناه. لا يتم أبدًا توسيع الصلاحية لتشمل الموقع بالكامل.',
  'vtw.restricted.identity': 'دليل الهوية',
  'vtw.restricted.identityRequired': 'مطلوب، ساري حتى انتهاء بيانات الدخول',
  'vtw.restricted.identityNotRequired': 'غير مطلوب',
  'vtw.restricted.escort': 'يجب تعيين مرافق',
};
